import { defineComponent } from 'vue'
import type { KnobProps } from './types'
import { KNOB_INNER_SIZE, KNOB_SIZE } from '../../constants'

const Knob = defineComponent<KnobProps>({
  setup(props) {
    return () => {
      return (
        <div
          style={{
            position: 'absolute',
            width: KNOB_SIZE + 'px',
            height: KNOB_SIZE + 'px',
            aspectRatio: '1 / 1',
            left: props.item.position.x + 'px',
            cursor: props.item.dragging ? 'none' : 'grab',
            top: 0,
            bottom: 0,
            marginBottom: 'auto',
            marginTop: 'auto',
            background: 'white',
            borderStyle: 'solid',
            borderRadius: '100%',
            pointerEvents: 'all',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 0px 7px 3px rgba(0,0,0,0.10), 0px 0px 3px 2px rgba(0,0,0,0.19)'
          }}
        >
            <div style={{
              height: (KNOB_INNER_SIZE) + 'px',
              width: (KNOB_INNER_SIZE) + 'px',
              background: props.item.color || '#409FFF',
              borderRadius: '100%'
            }}/>
        </div>
      )
    }
  }
})

Knob.props = ['item']

export default Knob
